var addValidate = false;
var i18n = require('i18n');
var util = require('../../app/util');
var doAjax = require('./ajax');
require('../../components/tag');
var pageConfig = window.pageConfig;
var topicId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);

var editorId = 'edit-topic';
var editTopicLayer = require('../../app/editorLayer.html');
var topicType = JSON.parse(JSON.stringify(pageConfig.topicType));
if (!pageConfig.admin) {
  delete topicType.notice;
}
$('body').append(editTopicLayer({
  id: editorId,
  title: i18n('edit.topic'),
  addTitle: true,
  topicType: util.toArray(topicType),
  tinymce: !pageConfig.markdown,
  markdown: !!pageConfig.markdown,
  lines: 15
}));
$('.edit-topic-layer').modal({
  closable: false,
  refresh: false,
  onHide: function () {
    window.scrollTo(0, window.enhancerScrollTop);
  },
  onHidden: function () {
    //$('.edit-topic-layer').modal('hide');
    $('.edit-topic-layer [name=title]').val('');
    $('.tab-list').find('.active').removeClass('active');
    $('.tab-list').find('.item:first').addClass('active');
    if (window.pageConfig.markdown) {
      $(this).find('.markdown-editor').val('');
    } else {
      tinyMCE.get('tinymce-' + editorId).setContent('');
    }
  }
});
$('.tab-list').on('click', '.item', function () {
  $(this).parent().find('.active').removeClass('active');
  $(this).addClass('active');
}).on('keyup', '.item', function (e) {
  if (e.keyCode === 32) {
    $(this).parent().find('.active').removeClass('active');
    $(this).addClass('active');
  }
});;

module.exports = function (success) {
  if (addValidate) {
      return;
  }
  addValidate = true;
  $.fn.form.settings.rules.tagsLength = function(value, aux, errors) {
    value = value.trim();
    return value.length < pageConfig.tags.length;
  };
  $.fn.form.settings.rules.tagsCount = function(value, aux, errors) {
    value = value.trim();
    return value.split(',').length < pageConfig.tags.count;
  };
  var layer = $('.edit-topic-layer');
  layer.form({
    inline: true,
    keyboardShortcuts: false,
    fields: {
      name: {
        identifier: 'title',
        rules: [{
          type   : 'empty',
          prompt : i18n('tip.input.title')
        },{
          type   : 'maxLength[' + pageConfig.topicTitle.max + ']',
          prompt : i18n('tip.title.name.length', {min: pageConfig.topicTitle.min, max: pageConfig.topicTitle.max})
        },{
          type   : 'minLength[' + pageConfig.topicTitle.min + ']',
          prompt : i18n('tip.title.name.length', {min: pageConfig.topicTitle.min, max: pageConfig.topicTitle.max})
        }]
      },
      tags: {
        identifier: 'tags',
        rules: [{
          type: 'tagsLength',
          prompt: i18n('tags.length', {max: pageConfig.tags.length})
        }, {
          type: 'tagsCount',
          prompt: i18n('tags.count', {max: pageConfig.tags.length})
        }]
      }
    }, 
    onSuccess: function (e, data) {
      data.type = $('.tab-list .active').data('type');
      data.tid = topicId;

      var oldContent;
      if (pageConfig.markdown) {
        data.content = data.markdown;
        oldContent = data.content;
        data.content = data.content.replace(new RegExp('</script>', 'gm'), '&lt;/script>');
      } else {
        oldContent = data.content;
        data.content = tinyMCE.get('tinymce-' + editorId).getContent({ format: "raw"});
      }


      if (data.content.length < pageConfig.topicContent.min || data.content.length > pageConfig.topicContent.max) {
        util.show(i18n('tip.content.length', {min: pageConfig.topicContent.min, max: pageConfig.topicContent.max}))
        return
      }

      data.markdown = undefined;
      data.editor = undefined;

      data.content = data.content.replace(/data-mce-src="[^"]+"/g, '');
      util.uploadImage(data.content, pageConfig.markdown ? 'markdown' : 'html', function (content) {
        data.content = content || data.content;
        var postData = {};
        var topic = pageConfig.topic;


        if (topic.editorType === 'markdown') {
          if (data.content !== pageConfig.markdown) {
            postData.content = data.content;
          }
        } else {
          if (data.content !== topic.content) {
            postData.content = data.content;
          }
        }
        

        if (data.title !== topic.title) {
          postData.title = data.title;
        }

        if (data.tags !== (topic.tags || []).join(',')) {
          postData.tags = data.tags;
        }

        if (data.type !== topic.type) {
          postData.type = data.type
        }


        data.content = oldContent;
        if (Object.keys(postData).length) {
          postData.tid = data.tid;
          if (postData.content) {
            postData.content = postData.content.replace(/blob:https:\/\/forum\.(enhancer|wuyuan)\.io\/[^'"]+/g, '');
          }
          doAjax('edit', postData, function (res) {
            $('.edit-topic-layer .close').click();
            success(res, data);
          });
        } else {
          $('.edit-topic-layer .close').click();
          success({success: true}, data);
        }
      });
    }
  });

  layer.find('.actions .button').on('keyup', function (e) {
    if (e.keyCode === 13) {
      layer.submit();
    }
  })

  $('input[name=tags]').tagsInput({
    defaultText: i18n('topic.tag'),
    onChange: function (input) {
    }
  });

  if (window.pageConfig.markdown) {
  } else {
    var createEditor = require('../../app/editor');
    createEditor(editorId);
  }
}



// WEBPACK FOOTER //
// ./src/pages/topic/editTopicLayer.js